import { render, staticRenderFns } from "./ProjectFiles.vue?vue&type=template&id=45fd1906&scoped=true"
import script from "./ProjectFiles.vue?vue&type=script&lang=js"
export * from "./ProjectFiles.vue?vue&type=script&lang=js"
import style0 from "./ProjectFiles.vue?vue&type=style&index=0&id=45fd1906&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fd1906",
  null
  
)

export default component.exports